import { render, staticRenderFns } from "./expoHotel.vue?vue&type=template&id=63c41b72&scoped=true"
import script from "./expoHotel.vue?vue&type=script&lang=js"
export * from "./expoHotel.vue?vue&type=script&lang=js"
import style0 from "./expoHotel.vue?vue&type=style&index=0&id=63c41b72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c41b72",
  null
  
)

export default component.exports